<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" @click="$router.push('/admin/downloads/toevoegen')" class="pull-right">Download toevoegen</b-button>
          </b-col>
        </b-row>
        <resource-index header="Downloads" endpoint="downloads" show-route="downloads.view"/>
      </div>
    </div>
  </div>
</template>

<script>
import ResourceIndex from '../../components/ResourceIndex';

export default {
  name: 'downloads',
  components: {ResourceIndex},
  computed: {
    userRole () {
      return this.$store.state.userRole
    }
  },
}
</script>
